const highlights: {
  id: number;
  title: string;
  author: {
    label: string;
    link?: {
      label: string;
      link: string;
    };
  };
  link?: string;
  details: string[];
  social?: {
    facebook?: string;
    linkedin?: string;
    twitter?: string;
  };
  imgPath: string
}[] = [{
  id: 1,
  title: 'The new face of retail: Tech trends to watch for in 2016',
  author: {
    label: 'By Melissa Gonzalez | Photo Grabbed',
    link: {
      label: 'NYDailyNews.com',
      link: 'http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732'
    }
  },
  link: 'http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732',
  details: ['Brands and retailers are incorporating virtual reality devices in-store to empower customers to test-drive products or services on a new level.', 'As technology continues to evolve, it continues to empower us. As a result, we have become more conditioned to expecting information, options, access and speed at our fingertips.'],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.nydailynews.com/life-style/new-face-retail-tech-trends-watch-2016-article-1.2506732'
  },
  imgPath: '/images/highlights/retail-trend.jpg'
},{
  id: 2,
  title: '2016 Predictions: Enterprise and managed mobility trends for 2016',
  author: {
    label: 'By Mitch Black, President, Mobi',
  },
  link: 'http://www.rcrwireless.com/20160129/opinion/2016-predictions-enterprise-and-managed-mobility-trends-for-2016-tag10',
  details: ['As we head into the new year, it’s time to take a look back at the key influences in mobility, management and security that will create the most impact on the enterprise in 2016. Active mobile devices now outnumber the world population and mobile Web traffic has surpassed that of the PC in the world’s most developed countries.'],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.rcrwireless.com/20160129/opinion/2016-predictions-enterprise-and-managed-mobility-trends-for-2016-tag10',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.rcrwireless.com/20160129/opinion/2016-predictions-enterprise-and-managed-mobility-trends-for-2016-tag10',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.rcrwireless.com/20160129/opinion/2016-predictions-enterprise-and-managed-mobility-trends-for-2016-tag10'
  },
  imgPath: '/images/highlights/fall-to-winter-frames-collection.jpg'
},{
  id: 3,
  title: 'Fixing the Fitting Room',
  author: {
    label: 'By Kim Bhasin | Photo Taken',
    link: {
      label: 'Bloomberg.com',
      link: 'http://www.bloomberg.com/news/articles/2016-01-19/fixing-the-fitting-room'
    }
  },
  link: 'http://www.bloomberg.com/news/articles/2016-01-19/fixing-the-fitting-room',
  details: ["Virtual reality and iPads won't change what's in the mirror, but better lighting and more staff may help sales.", 'Haley Bierman hates clothes shopping.', 'The 23-year-old Manhattan fundraiser points to how society uses fashion and television to browbeat girls about how they look from a young age. Like nowhere else, that self-doubt comes out in the fitting room.'],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.bloomberg.com/news/articles/2016-01-19/fixing-the-fitting-room',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.bloomberg.com/news/articles/2016-01-19/fixing-the-fitting-room',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.bloomberg.com/news/articles/2016-01-19/fixing-the-fitting-room'
  },
  imgPath: '/images/highlights/fixing-the-fitting-room.jpg'
},{
  id: 4,
  title: 'Can UrbanStems Change the Way You Buy Flowers?',
  author: {
    label: 'From www.wsj.com | Photo Taken',
    link: {
      label: 'Urbanstems.com',
      link: 'https://urbanstems.com/about'
    }
  },
  link: 'http://www.wsj.com/video/can-urbanstems-change-the-way-you-buy-flowers/1151D756-8E42-4DDA-9FEE-09FDA3D3CE94.html',
  details: ["What happens when flower delivery goes on-demand? UrbanStems co-founder Ajay Kori discusses his business model and the challenges of running a start-up with Tanya Rivero."],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.wsj.com/video/can-urbanstems-change-the-way-you-buy-flowers/1151D756-8E42-4DDA-9FEE-09FDA3D3CE94.html',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.wsj.com/video/can-urbanstems-change-the-way-you-buy-flowers/1151D756-8E42-4DDA-9FEE-09FDA3D3CE94.html',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.wsj.com/video/can-urbanstems-change-the-way-you-buy-flowers/1151D756-8E42-4DDA-9FEE-09FDA3D3CE94.html'
  },
  imgPath: '/images/highlights/urbanstems-change-the-way-buy-flowers.jpg'
},{
  id: 5,
  title: 'Meet The 25-Year-Old Swedish Woman Using 3D Scanning To Make Shoes Fit Perfectly',
  author: {
    label: "By Clare O'Connor | Photo Taken",
    link: {
      label: 'Forbes.com',
      link: 'http://www.forbes.com/sites/clareoconnor/2016/01/18/forbes-under-30-europe-volumental-caroline-walerud-3d-printing/#1b551b1e7281'
    }
  },
  link: 'http://www.forbes.com/sites/clareoconnor/2016/01/18/forbes-under-30-europe-volumental-caroline-walerud-3d-printing/#1b551b1e7281',
  details: ["What happens when flower delivery goes on-demand? UrbanStems co-founder Ajay Kori discusses his business model and the challenges of running a start-up with Tanya Rivero."],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.forbes.com/sites/clareoconnor/2016/01/18/forbes-under-30-europe-volumental-caroline-walerud-3d-printing/#1b551b1e7281',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.forbes.com/sites/clareoconnor/2016/01/18/forbes-under-30-europe-volumental-caroline-walerud-3d-printing/#1b551b1e7281',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.forbes.com/sites/clareoconnor/2016/01/18/forbes-under-30-europe-volumental-caroline-walerud-3d-printing/#1b551b1e7281'
  },
  imgPath: '/images/highlights/3D-scanning-to-Make-shoes.jpg'
},{
  id: 6,
  title: 'The Future of Retail Lies in Augmented Reality',
  author: {
    label: "By Andrei Klubnikin | Photo Grabbed",
    link: {
      label: 'Tech.Co',
      link: 'http://tech.co/future-retail-lies-augmented-reality-2015-12'
    }
  },
  link: 'http://tech.co/future-retail-lies-augmented-reality-2015-12',
  details: ["By 2020, augmented and virtual reality market will be worth $ 150 billion. Google, Microsoft and Facebook have already made large investments in AR solutions; still, some experts fail to predict where the market is actually going. There are several industries that will benefit from AR applications, including healthcare, tourism and entertainment. However, it is retailers who’ll be the first to hit the AR jackpot."],
  social: {
    twitter: 'https://twitter.com/share?url=http://tech.co/future-retail-lies-augmented-reality-2015-12',
    facebook: 'https://www.facebook.com/sharer.php?u=http://tech.co/future-retail-lies-augmented-reality-2015-12',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://tech.co/future-retail-lies-augmented-reality-2015-12'
  },
  imgPath: '/images/highlights/the-future-of-retail-lies-in-augmented-reality.jpg'
},{
  id: 7,
  title: 'Light and ocular pathologies : Risk prevention in ophthalmology',
  author: {
    label: "By Berthemy, Sylvie"
  },
  link: 'http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology',
  details: ["Ultraviolet radiation, among other aetiological factors, is implicated in several ocular pathologies. Dr. Sylvie Berthemy describes the most common clinical cases and identifies the most vulnerable population groups for Points de Vue. She also stresses the importance of including prevention in her clinical and medical practice."],
  social: {
    twitter: 'https://twitter.com/share?url=http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology',
    facebook: 'https://www.facebook.com/sharer.php?u=http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology'
  },
  imgPath: '/images/highlights/fall-to-winter-frames-collection.jpg'
},{
  id: 8,
  title: '8 Retail Trends to Prepare for This Year',
  author: {
    label: "By Rieva Lesonsky | Photo Taken",
    link: {
      label: 'SmallBizTrends.com',
      link: 'http://smallbiztrends.com/2016/04/8-upcoming-retail-trends.html'
    }
  },
  link: 'http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology',
  details: ["Perhaps no industry is changing more rapidly than retail. To help you keep up, I’ve gathered some predictions from two recent retail studies, “How We Shop Now,” and a report by TOBE presented at the National Retail Federation’s Big Show, that will give you insight into upcoming retail trends and may help your business."],
  social: {
    twitter: 'https://twitter.com/share?url=http://smallbiztrends.com/2016/04/8-upcoming-retail-trends.html',
    facebook: 'https://www.facebook.com/sharer.php?u=http://smallbiztrends.com/2016/04/8-upcoming-retail-trends.html',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://smallbiztrends.com/2016/04/8-upcoming-retail-trends.html'
  },
  imgPath: '/images/highlights/2016-retail-trends.jpg'
},{
  id: 9,
  title: 'Top Converting Ecommerce Businesses And How They Do It',
  author: {
    label: "By Jonha Richman | Photo Taken",
    link: {
      label: 'SmallBizTrends.com',
      link: 'http://smallbiztrends.com/2016/04/10-converting-ecommerce-sites.html'
    }
  },
  link: 'http://www.pointsdevue.com/article/light-and-ocular-pathologies-risk-prevention-ophthalmology',
  details: ["With the constant increase in ecommerce trends, more small businesses are experimenting with online selling. But cart abandonment continues to be a big issue. If you want to know how sales on your ecommerce site can be improved (and who doesn’t), consider this. The experts at InFlow created video site reviews using four retail brands and point out what they did well and not so well from a conversion optimization standpoint."],
  social: {
    twitter: 'https://twitter.com/share?url=http://smallbiztrends.com/2016/04/10-converting-ecommerce-sites.html',
    facebook: 'https://www.facebook.com/sharer.php?u=http://smallbiztrends.com/2016/04/10-converting-ecommerce-sites.html',
    linkedin: 'https://www.linkedin.com/shareArticle?url=http://smallbiztrends.com/2016/04/10-converting-ecommerce-sites.html'
  },
  imgPath: '/images/highlights/converting-sites.jpg'
}]

export default highlights;